import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { TCatalogGraphicOption } from '@partners/catalog';
import { ThemeAssetComponent } from '@partners/themes';

@Component({
  selector: 'gender-option',
  standalone: true,
  imports: [ThemeAssetComponent],
  template: `
    <span class="icon"><theme-asset [asset]="option().icon" /></span>
    <span class="label">{{ option().key }}</span>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .icon {
        display: grid;
        place-content: center;
      }
      .label {
        position: absolute;
      }
      .theme-asset {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0px;
        transform: scale(1.5);
      }
    `
  ]
})
export class GenderOptionComponent {
  option = input.required<TCatalogGraphicOption>();
}
